import Vue from 'vue'
import store from '@/store'
import VuexI18n from 'vuex-i18n/dist/vuex-i18n.umd.js'
import * as rtlDetect from 'rtl-detect'
const en = require('./translations-strings/translations.json')

let languages = {
  imported: false,
  en,
  af: require('./translations-strings/translations-af.json'),
  ar: require('./translations-strings/translations-ar.json'),
  de: require('./translations-strings/translations-de.json'),
  fr: require('./translations-strings/translations-fr.json'),
  pt: require('./translations-strings/translations-pt.json'),
  es: require('./translations-strings/translations-es.json'),
  br: require('./translations-strings/translations-pt_BR.json'),
  hu: require('./translations-strings/translations-hu.json'),
  zh: require('./translations-strings/translations-zh_CN.json'),
  ja: require('./translations-strings/translations-ja.json'),
  nl: require('./translations-strings/translations-nl.json'),
  it: require('./translations-strings/translations-it.json')
}
try {
  if (process.env.getTranslationStrings) {
    languages = {
      imported: true,
      en,
      af: require('./translations-strings/translations-af.json'),
      ar: require('./translations-strings/translations-ar.json'),
      de: require('./translations-strings/translations-de.json'),
      fr: require('./translations-strings/translations-fr.json'),
      pt: require('./translations-strings/translations-pt.json'),
      es: require('./translations-strings/translations-es.json'),
      br: require('./translations-strings/translations-pt_BR.json'),
      hu: require('./translations-strings/translations-hu.json'),
      zh: require('./translations-strings/translations-zh_CN.json'),
      ja: require('./translations-strings/translations-ja.json'),
      nl: require('./translations-strings/translations-nl.json'),
      it: require('./translations-strings/translations-it.json')
    }
  }
} catch (e) {
  console.error('cannot import translation string files: ', e)
}

export const setLanguage = (language) => {
  const usersUIlanguage = store.getters['user/language']
  Vue.i18n.set(language || usersUIlanguage)
}

export const loadLanguages = (store) => {
  Vue.use(VuexI18n.plugin, store)
  Vue.i18n.add('en', languages.en)
  Vue.i18n.fallback('en')
  Vue.i18n.set('en') // use english as default
  // if (languages.imported) { not using this setting yet
  Vue.i18n.add('af', languages.af)
  Vue.i18n.add('ar', languages.ar)
  Vue.i18n.add('de', languages.de)
  Vue.i18n.add('fr', languages.fr)
  Vue.i18n.add('it', languages.it)
  Vue.i18n.add('pt', languages.pt)
  Vue.i18n.add('es', languages.es)
  Vue.i18n.add('br', languages.br)
  Vue.i18n.add('hu', languages.hu)
  Vue.i18n.add('zh', languages.zh)
  Vue.i18n.add('ja', languages.ja)
  Vue.i18n.add('nl', languages.nl)
  // }
}

export const setHtmlTagLangAndRtl = (language) => {
  if (language) {
    const htmlDoc = document.documentElement
    const dir = isRtlLanguage(language) ? 'rtl' : 'ltr'
    htmlDoc.dir = dir
    htmlDoc.lang = language.substring(0, 2)
  }
}

export const isRtlLanguage = (language) => rtlDetect.isRtlLang(language)

export default {
  isRtlLanguage,
  loadLanguages,
  setLanguage,
  setHtmlTagLangAndRtl
}
